<template>
  <div class="m-base-title app-flex-mid-center">
    <div class="primary-title">{{ title }}</div>
    <div class="rich-title">{{ richTitle }}</div>
  </div>
</template>

<script>
export default {
  name: 'MBaseTitle',
  props: {
    title: String,
    richTitle: String
  }
}
</script>

<style lang="scss" scoped>
.m-base-title {
  margin-top: 40px;
  flex-direction: column;
  user-select: none;
  .primary-title {
    border-bottom: 1px solid #eb543c;
    font-size: 22px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #000000;
    line-height: 31px;
  }
  .rich-title {
    margin-top: 5px;
    font-size: 12px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #eb543c;
    line-height: 17px;
    text-transform: Uppercase;
  }
}
</style>
